<template>
    <div>
        <el-col :span="10" class="logo" :class="{'logo-collapse-width':collapsed,'logo-width':!collapsed}">
            {{collapsed?'':sysName}}
        </el-col>
        <el-col :span="10">
            <div class="tools" @click.prevent="collapse">
                <i class="fa fa-align-justify" style="cursor: pointer!important;"></i>
            </div>
        </el-col>
        <el-col :span="4" class="userinfo">
            <el-dropdown trigger="hover">
                    <span class="el-dropdown-link userinfo-inner"><img
                            :src="sysUserAvatar"/> {{sysUserName}}</span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-col>
    </div>
</template>

<script>
    export default {
        name: "mheader",
        data() {
            return {
                sysUserName: 'Porter Wang',
                sysUserAvatar: 'https://randomuser.me/api/portraits/men/85.jpg',
                sysName: '意臣科技',
                collapsed: false
            }
        },
        methods: {
            //折叠导航栏
            collapse: function () {
                this.$store.dispatch('sysAdmin/switchCollasped')
                this.collapsed = this.$store.state.sysAdmin.collapsed;
            },
            //退出登录
            logout: function () {
                this.$confirm('确认退出吗?', '提示').then(() => {
                    this.$store.dispatch("sysAdmin/adminLogout")
                        .then(response => {
                            if (response && response.data.success) {
                                this.$router.push('/admin/login')
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.data.message
                                })
                            }
                        })
                })
            },
        },
        mounted() {
            this.collapsed = this.$store.state.sysAdmin.collapsed
            let user = localStorage.getItem('admin');
            if (user) {
                user = JSON.parse(user);
                this.sysUserName = user.name || '';
                if(user.avatar){
                    this.sysUserAvatar = user.avatar
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~scss_vars';

    .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;

        .userinfo-inner {
            cursor: pointer;
            color: #fff;

            img {
                width: 40px;
                height: 40px;
                border-radius: 20px;
                margin: 10px 0px 10px 10px;
                float: right;
            }

        }
    }

    .logo {
        height: 60px;
        font-size: 22px;
        padding-left: 20px;
        padding-right: 20px;
        border-color: rgba(238, 241, 146, 0.3);
        border-right-width: 1px;
        border-right-style: solid;

        img {
            width: 40px;
            float: left;
            margin: 10px 10px 10px 18px;
        }

        .txt {
            color: #fff;
        }
    }

    .logo-width {
        width: 169px;
    }

    .logo-collapse-width {
        width: 60px
    }

    .tools {
        padding: 0px 23px;
        width: 14px;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
    }

    .collapsed {
        width: 60px;

        .item {
            position: relative;
        }

        .submenu {
            position: absolute;
            top: 0px;
            left: 60px;
            z-index: 99999;
            height: auto;
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// VHeader.vue?6bf69c40